import { BaseEntity } from '../base-entity';

export class FormSec002Filter extends BaseEntity {
    // tslint:disable-next-line: variable-name
    safra?: string;
    // tslint:disable-next-line: variable-name
    hibrido_rnc_linhagem?: string;
    // tslint:disable-next-line: variable-name
    site_recebimento?: string;
    // tslint:disable-next-line: variable-name
    controle_secagem?: string;
    // tslint:disable-next-line: variable-name
    secador_camara?: string;
    // tslint:disable-next-line: variable-name
    is_incomplete?: boolean;
    lote_ds?: string;
    silo_destino?: string;
    local_atual?:string;
    n_de_campo_basica?: string;
}
